import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useEffect, useState } from "react";

import { StageProps } from "../../../redux/Hire/jobRequestApi";
import SortableItem from "./SortableItem";

type Props = {
  statusList: Array<StageProps>;
  selectedStages: Record<string, boolean>;
  formikSet: (states: Array<StageProps>) => void;
};

function SortableList({ statusList, selectedStages, formikSet }: Props) {
  const [items, setItems] = useState(statusList);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  useEffect(() => {
    setItems(statusList.filter((el) => selectedStages[el.key]));
  }, [statusList, selectedStages]);

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={items.map((el) => el.key)}
        strategy={verticalListSortingStrategy}
      >
        {items.map((item) => (
          <SortableItem
            id={item.key}
            key={item.key}
            mandatory={item.mandatory}
            allowDirectTransition={item.allowDirectTransition}
            name={item.name}
          />
        ))}
      </SortableContext>
    </DndContext>
  );

  function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.findIndex((el) => el.key === active.id);
        const newIndex = items.findIndex((el) => el.key === over.id);
        const newList = arrayMove(items, oldIndex, newIndex);
        formikSet(newList);
        return newList;
      });
    }
  }
}

export default SortableList;
